import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import qs from "qs";
import router from "../router/router";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    view: {
      isLoading: true,
      isLoadingProducts: false,
      isLoadingAttributes: false,
      type: ws_vue_store.config["product-grid"],
      categoryPath: '',
      sort: "default",
      perPage: 50,
      perPageOptions: [10, 25, 50, 75, 100, 125],
      page: 1
    },
    filters: {
      first: null,
      current: {},
      onSaleProducts: false,
      newProducts: false,
      priceSlider: {
        min: null,
        max: null
      }
    },
    numberSeparator : ',',
    searchMode: false,
    productsHighestPrice: 0,
    productsCount: 0,
    discountCategory: 0,
    rentCategory: 0,
    searchProducts: [],
    featuredProducts: [],
    recentlyAddedProducts: [],
    selectedPackages: {},
    products: [],
    // loadedTerms: [],
    attributeTaxonomies: [],
    filteredAttributeTaxonomies: [],
    allowedCategoryAttributes: [],
    showExcludedAttributes: true,
    attributesFirstLoadingState: true,
    categories: [],
    previouslyViewed: [],
  },
  getters: {
    getNumberSeparator: state => {
      return state.numberSeparator;
    },
    getFiltersFromUrl: state => () => {
      var queryParams = qs.parse(window.location.search.substr(1));
      // Set default options for missing query filters
      // Needed so that going back in browser history won't break pagination filtering
      if ( ! queryParams.ws_sort)
        queryParams.ws_sort = ws_vue_store.catalog_orderby_options[0].code;
      if ( ! queryParams.ws_page)
        queryParams.ws_page = 1
      if ( ! queryParams.ws_per_page)
        queryParams.ws_per_page = 50;

      return queryParams;
    },
    getActiveFiltersCount: state => {
      let filters = Object.keys(state.filters.current);

      // Empty filters button functionality
      // Ignore category option
      if (ws_vue_store.empty_filters_ignore_category) {
        let t = filters.indexOf('product_cat')
        if (t != -1)
          filters.splice(t, 1);
      }

      return filters.length;
    },
    getSearchMode: state => {
      return state.searchMode;
    },
    getType: state => {
      return state.view.type;
    },
    getAttributeTaxonomy: state => key => {
      if (state.attributeTaxonomies.length === 0) {
        return null;
      }
      const foundAttributeTaxonomy = state.attributeTaxonomies.find(
        attributeTaxonomy => attributeTaxonomy.key === key
      );
      if (foundAttributeTaxonomy === undefined) {
        return null;
      }
      return foundAttributeTaxonomy;
    },
    getProducts: state => {
      return state.products;
    },
    getDiscountCategory: state => {
      return state.discountCategory;
    },
    getRentCategory: state => {
      return state.rentCategory;
    },
    getFilteredAttributeTaxonomies: (state, getters) => {
      const allowed_sidebar_filters = ws_vue_store.config['allowed_sidebar_filters'];

      if(ws_vue_store.disable_filters_relationship == 1){
        state.filteredAttributeTaxonomies.map(attribute => {
          attribute.options.map(option => {
            option.excluded_filter = false;
          })
        });
      }

      if(Object.keys(state.filters.current).length == 0){
        return state.filteredAttributeTaxonomies;
      }
      if(state.attributesFirstLoadingState){
        state.attributesFirstLoadingState = false;
        return state.filteredAttributeTaxonomies;
      }
      if(allowed_sidebar_filters == undefined) return [];
      let allAttributes = state.attributeTaxonomies.filter(attr => allowed_sidebar_filters.includes(attr.key));

      if(ws_vue_store.disable_filters_relationship == 1){
        return allAttributes;
      }
      
      state.filteredAttributeTaxonomies.map(attr => {
        let findAttributeIndex = allAttributes.findIndex(attribute => attribute.key == attr.key);
        if(findAttributeIndex != -1){
          allAttributes[findAttributeIndex].options.map(option => {
            if(attr.options.find(opt => opt.slug == option.slug)){
              option.excluded_filter = false;
            } else {
              option.excluded_filter = true;
            }
          })
        }
      });

      allAttributes.map(attribute => {
        let found = state.filteredAttributeTaxonomies.find(attr => attr.key == attribute.key);
        if(!found){
          attribute.options.map(option => {
            option.excluded_filter = true;
          });
        }
      });

      return allAttributes;
    },
    getSearchedProducts: (state, getters) => {
      return state.searchProducts;
    },
    getFeaturedProducts: (state, getters) => {
      return state.featuredProducts;
    },
    getRecentlyAddedProducts: (state, getters) => {
      return state.recentlyAddedProducts;
    },
    getSelectedPackages: (state, getters) => {
      return state.selectedPackages;
    },
    getHighestPrice: (state, getters) => {
      return state.productsHighestPrice;
    },
    isDiscountedProductsPage(state, getters){
      return state.filters.onSaleProducts;
    },
    isNewProductsPage(state, getters){
      return state.filters.newProducts;
    },
    isHomePage: (state) => () => {
      if (Object.keys(state.filters.current).length || state.filters.keyword) {
        return false;
      }

      return true;
    },
    getAllowedAttributes(state, getters){
      let allowedAttributes = ws_vue_store.config.allowed_attributes;
      if(state.allowedCategoryAttributes != undefined && state.allowedCategoryAttributes.length > 0){
        return state.allowedCategoryAttributes;
      }
      return allowedAttributes;
    }
  },
  mutations: {
    changeLoadingState(state, newState) {
      state.view.isLoading = newState;
    },
    changeProductsLoadingState(state, newState) {
      state.view.isLoadingProducts = newState;
    },
    changeAttributesLoadingState(state, newState) {
      state.view.isLoadingAttributes = newState;
    },
    changeViewType(state, newType) {
      state.view.type = newType;
    },
    changePerPage(state, value) {
      state.view.perPage = parseInt(value, 10);
      if (parseInt(router.currentRoute.query.ws_per_page) !== parseInt(value, 10)) {
        router.push({ query: { ...router.currentRoute.query, ws_per_page: parseInt(value, 10) } });
      }
    },
    scrollToSavedPosition(state) {
      const savedYPosition = sessionStorage.getItem(window.location.href);
      if (savedYPosition) {
        window.scrollTo(0, savedYPosition);
      }
    },
    setFirstPage(state) {
      state.view.page = 1;
    },
    changeCurrentPage(state, newVal) {
      // Keep pagination on page refresh or from page link
      if (state.view.isLoading) {
        state.view.page = newVal;
        return;
      }

      if (state.productsCount === 0 || newVal < 1) {
        state.view.page = 1;
      } else if (state.productsCount >= (((newVal - 1) * state.view.perPage) + 1)) {
        state.view.page = newVal;
      } else {
        state.view.page = 1;
      }

      if (parseInt(router.currentRoute.query.ws_page, 10) !== parseInt(state.view.page, 10)) {
        router.push({
          query: {
            ...router.currentRoute.query,
            ws_page: parseInt(state.view.page, 10)
          }
        });
      }
    },
    changeShowExcludedAttributes(state, newVal){
      state.showExcludedAttributes = newVal;
    },
    changeAttributesFirstLoadingState(state, newVal){
      state.attributesFirstLoadingState = newVal;
    },
    setProductsHighestPrice(state, price) {
      state.productsHighestPrice = Math.ceil(price);
    },
    setProductsCount(state, count) {
      state.productsCount = count;
    },
    setSearchProducts(state, products) {
      state.searchProducts = products;
    },
    setFeaturedProducts(state, products) {
      state.featuredProducts = products;
    },
    setRecentlyAddedProduct(state, product){
      state.recentlyAddedProducts.push(product);
    },
    setSelectedPackages: (state, data) => {
      return state.selectedPackages = data;
    },
    addSelectedPackages: (state, data) => {
      return state.selectedPackages[data.id] = data.package;
    },
    setProducts(state, products) {
      state.products = products;
    },
    setDiscountCategory(state, discountCategory) {
      state.discountCategory = discountCategory;
    },
    setRentCategory(state, rentCategory) {
      state.rentCategory = rentCategory;
    },
    setFilteredAttributeTaxonomies(state, filteredAttributeTaxonomies){
      const allowed_sidebar_filters = ws_vue_store.config['allowed_sidebar_filters'];
      if(allowed_sidebar_filters == undefined) return [];
      state.filteredAttributeTaxonomies = filteredAttributeTaxonomies.filter(attr => allowed_sidebar_filters.includes(attr.key));
    },
    setAttributeTaxonomies(state, attributeTaxonomies) {
      state.attributeTaxonomies = attributeTaxonomies;
    },

    setCategories(state, categories) {
      state.categories = categories;
    },

    setNumberSeparator(state, separator) {
      state.numberSeparator = separator;
    },

    setCategoryFromPath(state, routeParams) {
      // Get last category slug if url is at a child category
      let currentCategorySlug = routeParams.split('/').at(-1);
      const matchingCategory = state.categories.find(
        category => category.slug === currentCategorySlug
      );
      if (matchingCategory) {
        state.filters.current = { ...state.filters.current, ["product_cat"]: [matchingCategory.term_id] };
      }
    },

    updatePriceFilter(state, payload){
      if(payload.type == 'min'){
        state.filters.priceSlider.min = payload.value;
      } else if(payload.type == 'max'){
        state.filters.priceSlider.max = payload.value;
      }
    },

    updateCategoryPath(state) {
      if (state.filters.current && state.filters.current.product_cat) {
        let slugs = [];
        let currentID = state.filters.current.product_cat[0];
        let currentCat = null;
        while (currentID) {
          currentCat = state.categories.find(c => c.term_id === currentID);
          if (currentCat) {
            slugs.push(currentCat.slug);
            currentID = currentCat.parent;
          } else {
            currentID = 0;
          }
        }

        if (slugs.length) {
          let path = slugs.reverse().join('/');
          state.view.categoryPath = `/${ws_vue_store.sub_urls.category_base}/${path}/`;
          return;
        }
      }

      // If no category selected, use default shop url
      state.view.categoryPath = `${ws_vue_store.sub_urls.shop}/`;
    },

    addFilter(state, payload) {
      if (payload.option === undefined || payload.taxonomy === undefined) {
        return;
      }

      if(payload.taxonomy == 'lang'){
        state.lang = payload.option;
        return;
      }

      if (state.filters.first === null) {
        state.filters.first = payload.taxonomy;
      }

      if(payload.taxonomy == 'keyword'){
        state.filters.keyword = payload.option;
        return;
      }

      if(payload.taxonomy == "product_cat"){
        if(isNaN(payload.option)) return;
      }

      if(payload.taxonomy == 'on_sale_products'){
        state.filters.onSaleProducts = payload.option;
        return;
      }

      if(payload.taxonomy == 'is_new'){
        state.filters.newProducts = payload.option;
        return;
      }

      if (
        state.filters.current[payload.taxonomy] === undefined ||
        payload.taxonomy === "product_cat"
      ) {
        state.filters.current = { ...state.filters.current, [payload.taxonomy]: [payload.option] };
        return;
      }
      state.filters.current = {
        ...state.filters.current,
        [payload.taxonomy]: [
          ...new Set([...state.filters.current[payload.taxonomy], payload.option])
        ]
      };
    },
    removeFilter(state, payload) {
      if (payload.taxonomy in state.filters) {
        delete state.filters[payload.taxonomy];

      } else if (payload.taxonomy in state.filters.current) {
        if (
          payload.taxonomy === "product_cat" &&
          state.filters.current[payload.taxonomy].length === 1
        ) {
          // If removing category then remove all taxonomy options as well
          state.filters.current = {};
          state.filters.first = null;

        } else if (state.filters.current[payload.taxonomy].length === 1) {
          // If filter will be empty, remove it completely
          delete state.filters.current[payload.taxonomy];

          if (state.filters.first === payload.taxonomy) {
            let currentFilters = Object.keys(state.filters.current);
            let validFilterIndex = currentFilters.findIndex(
                filterKey => state.filters.current[filterKey].length
            );

            if (validFilterIndex == -1) {
              state.filters.first = null;
            } else {
              state.filters.first = currentFilters[validFilterIndex];
            }
          }

        } else {
          // Remove filter option from array
          state.filters.current[payload.taxonomy] = state.filters.current[payload.taxonomy].filter(
            filter => filter !== payload.option
          );
        }

        if (payload.taxonomy === "product_cat") {
          state.view.categoryPath = `${ws_vue_store.sub_urls.shop}/`;
        }
      }
    },
    clearFilters(state, options) {
      if (options.ignoreCategory && state.filters.current.product_cat) {
        state.filters.current = {
          product_cat: state.filters.current.product_cat
        };
      } else {
        state.filters.current = {};
      }

      state.filters.first = null;
      state.filters.priceSlider.min = 0;
      state.filters.priceSlider.max = 0;
      state.view.page = 1;
      state.showExcludedAttributes = true;
    },
    updateUrlQuery(state) {
      const mapped = {};

      Object.keys(state.filters.current).forEach(key => {
        mapped[`ws_${key}`] = state.filters.current[key];
      });
      delete(mapped.ws_product_cat); // Don't add category id to url

      if(typeof state.filters.keyword !== 'undefined' && state.filters.keyword){
        mapped['search_term'] = state.filters.keyword;
      }

      if(typeof state.lang !== 'undefined' && state.lang){
        mapped['lang'] = state.lang;
      }

      if(typeof state.filters.onSaleProducts !== 'undefined' && state.filters.onSaleProducts){
        mapped['on_sale_products'] = state.filters.onSaleProducts;
      }

      if(typeof state.filters.newProducts !== 'undefined' && state.filters.newProducts){
        mapped['is_new'] = state.filters.newProducts;
      }

      if (state.view.page > 1) {
        mapped['ws_page'] = state.view.page;
      }

      if (state.view.perPage != 50) {
        mapped['ws_per_page'] = state.view.perPage;
      }

      if (state.view.sort.code != ws_vue_store.catalog_orderby_options[0].code) {
        mapped['ws_sort'] = state.view.sort.code;
      }

      router.push({ path: state.view.categoryPath, query: mapped });
    },

    setSort(state, selected) {
      state.view.sort = selected;
      if (router.currentRoute.query.ws_sort !== selected.code && selected.code !== ws_vue_store.catalog_orderby_options[0].code) {
        router.push({ query: { ...router.currentRoute.query, ws_sort: selected.code } });
      }
    },

    addProductToViewedList(state, product) {
      if (!product) {
        return;
      }
      if (state.previouslyViewed.length >= parseInt(ws_vue_store.previous_views_quantity, 10)) {
        state.previouslyViewed.splice(0, 1);
      }
      let productFound = state.previouslyViewed.find(p => p.id == product.id);

      if (!state.previouslyViewed.includes(product) && !productFound) {
        state.previouslyViewed = [product, ...state.previouslyViewed];
      }
    },

    changeSearchMode(state, newState){
      state.searchMode = newState;
    },
    setCategoryAllowedAttributes(state, newState){
      state.allowedCategoryAttributes = newState;
    }
  },
  actions: {
    async getFeaturedProducts({ commit, state }, payload)
    {

      /* FEATURED PRODUCTS */
      axios.get(ws_vue_store.featured_products_endpoint + ws_vue_store.language_code)
        .then(response => {
          if (response.data) {
            commit("setFeaturedProducts", response.data.data);
          }
        })
        .catch(err => {
          // eslint-disable-next-line no-console
          console.error(err);
        });
      /***********************/
    },
    async searchProducts({ commit, state }, payload) {
      if(typeof payload.keyword == undefined) return;

      let postData = {
        'filters': {
          'keyword': payload.keyword,
          'languageCode': ws_vue_store.language_code,
          'keyword_extra_fields': ws_vue_store.search_additional_fields
        },
        'sort': 'search',
        'pageLimit': 5
      }

      // `ws-wc-role-discounts` plugin data
      if (ws_vue_store.discount_rules) {
        postData['filters']['discountRules'] = ws_vue_store.discount_rules
      }

      if (ws_vue_store.search_exclude_description) {
        postData['filters']['keyword_exclude_description'] = true;
      }

      if (ws_vue_store.attribute_custom_order == '1') {
        postData['attr_custom_order'] = true;
      }

      if (ws_vue_store.new_product_categories) {
        postData['new_cate'] = ws_vue_store.new_product_categories;
      }

      try {
        const result = await axios.post(ws_vue_store.products_endpoint, postData);

        if (result && result.data && result.data.state == 'OK') {
          commit('setSearchProducts', result.data.list);
        }
      } catch (error) {
        console.error("Request error:", error);
      }
    },
    async getProducts({ commit, dispatch, state, getters}) {
      var isHomePage = getters.isHomePage();

      if ( ! isHomePage) {
        commit('setFeaturedProducts', []);
      } else {
        dispatch('getFeaturedProducts');
      }

      let postData = {
        'filters': {
          ...state.filters.current,
          'keyword': state.filters.keyword ? state.filters.keyword : null,
          'priceSlider': state.filters.priceSlider,
          'languageCode': ws_vue_store.language_code,
          'keyword_extra_fields': ws_vue_store.search_additional_fields
        },
        'custom_price': {},
        'product_custom_fields' : {},
        'sort': state.view.sort.code,
        'pageIndex': state.view.page - 1,
        'pageLimit': state.view.perPage
      }

      if (state.filters.keyword) {
        postData['sort'] = 'search';
      }

      if (ws_vue_store.search_exclude_description) {
        postData['filters']['keyword_exclude_description'] = true;
      }

      if (ws_vue_store.new_product_categories) {
        postData['new_cate'] = ws_vue_store.new_product_categories;
      }

      if (ws_vue_store.attribute_custom_order == '1') {
        postData['attr_custom_order'] = true;
      }

      if (ws_vue_store.custom_order_for_variations == '1') {
        postData['vari_custom_order'] = true;
      }

      if(state.filters.onSaleProducts != undefined && state.filters.onSaleProducts){
        postData['filters']['on_sale_products'] = state.filters.onSaleProducts;
      }

      if(state.filters.newProducts != undefined && state.filters.newProducts){
        postData['filters']['is_new'] = state.filters.newProducts;
      }
      if(isHomePage){
        postData['filters']['is_featured'] = true;
        postData['sort'] = 'featured';
      }

      // `ws-wc-role-discounts` plugin data
      if (ws_vue_store.discount_rules) {
        postData['filters']['discountRules'] = ws_vue_store.discount_rules
      }

      if(ws_vue_store.config['product-grid'] == 'wells'){
        let allowedAttributes = ws_vue_store.config.allowed_attributes;
        if(state.allowedCategoryAttributes != undefined && state.allowedCategoryAttributes.length > 0){
          allowedAttributes = state.allowedCategoryAttributes;
        }
        postData['include_meta_fields'] = true;
        
        // if(allowedAttributes.length > 0){
        //   let metaFields = allowedAttributes.map(function(attribute, index){
        //     return 'attribute_' + attribute;
        //   });
        //   postData['meta_fields'] = metaFields;
        // }
      }

      // Company and project discount - (hekamerk)
      if(ws_vue_store.company_id){
        postData['custom_price']['company_id'] = ws_vue_store.company_id;
      }
      if(ws_vue_store.project_searchcode){
        postData['custom_price']['project_searchcode'] = ws_vue_store.project_searchcode;
      }

      if(ws_vue_store.show_measurement_unit == '1'){
        postData['product_custom_fields'].measurement_unit = 'string';
      }

      if(ws_vue_store.enable_buying_step == '1'){
        postData['product_custom_fields'].buying_step = 'float';
      }

      if(ws_vue_store.is_rent_category_set == '1'){
        postData['product_custom_fields'].is_rentable = 'int';
      }

      try {
        const result = await axios.post(ws_vue_store.products_endpoint, postData);

        if (result && result.data && result.data.state == 'OK') {
          commit('setProductsCount', result.data.total);
          commit('setProducts', result.data.list);
          commit('setDiscountCategory', result.data.discount_category);
          commit('setRentCategory', result.data.rent_category);
          commit('changeLoadingState', false);
          commit('changeProductsLoadingState', false);
        } else {
          // TODO: show something to user or just loading screen will be shown to user
        }
      } catch (error) {
        console.error("Request error:", error);
        // TODO: endpoint is messed up
      }
    },
    setFiltersFromUrl({ commit, state, getters }) {
      const queryParams = getters.getFiltersFromUrl();

      if(queryParams.search_term || queryParams.search_term != undefined){
        commit('changeSearchMode', true);

        commit("addFilter", {
          taxonomy: 'keyword',
          option: Array.isArray(queryParams.search_term) ? queryParams.search_term[0] : queryParams.search_term
        });

        delete queryParams.search_term;
      }

      if (queryParams.ws_sort) {
        state.view.sort = ws_vue_store.catalog_orderby_options.find(sort => sort.code === queryParams.ws_sort);
        delete queryParams.ws_sort;
      }

      if (queryParams.ws_per_page) {
        state.view.perPage = parseInt(queryParams.ws_per_page, 10);
        delete queryParams.ws_per_page;
      }

      if (queryParams.ws_page && Number(queryParams.ws_page)) {
        state.view.page = parseInt(queryParams.ws_page, 10);
        delete queryParams.ws_page;
      }

      if (router.currentRoute.params && router.currentRoute.params.category_slug) {
        commit("setCategoryFromPath", router.currentRoute.params.category_slug);
      }
      commit("updateCategoryPath");

      Object.keys(queryParams).forEach(key => {
        if (Array.isArray(queryParams[key])) {
          queryParams[key].forEach(option => {
            commit("addFilter", {
              taxonomy: key.replace("ws_", ""),
              option: key === "ws_product_cat" ? parseInt(option, 10) : option
            });
          });
        } else {
          commit("addFilter", {
            taxonomy: key.replace("ws_", ""),
            option: key === "ws_product_cat" ? parseInt(queryParams[key], 10) : queryParams[key]
          });
        }
      });
    },
    async getAttributes({ commit, state }) {
      try {
        const url = ws_vue_store.attributes_endpoint + ws_vue_store.language_code;
        const result = await axios.get(url);

        if (result && result.data && result.data.state == 'OK') {
        }
      } catch (error) {
        console.error("Request error:", error);
        // TODO: endpoint is messed up
      }
    },
    async getFilteredAttributes({ commit, state, getters }) {
      let postData = {
        'filters': {
          'priceSlider': state.filters.priceSlider,
          'languageCode': ws_vue_store.language_code,
        },
        'show_excluded': state.showExcludedAttributes
      }

      if (ws_vue_store.filter_attributes_by_category !== '1') {
        Object.assign(postData.filters, state.filters.current);
      } else if (state.filters.current.product_cat) {
        // Send only category filter because we wan't to
        // always show all valid category attribute options.
        // Attribute filtering will hide other options away.
        postData.filters['product_cat'] = state.filters.current.product_cat;
      }

      // Add search keyword
      if (state.filters.keyword) {
        postData.filters.keyword = state.filters.keyword;

        // If using search keyword and having no categories
        // then filters will start showing wrong excluded
        // options. This is fast fix for it.
        if (state.filters.current.product_cat == undefined) {
          postData.show_excluded = false;
        }
      }

      if (ws_vue_store.attribute_custom_order == '1' || ws_vue_store.filter_options_custom_order == '1') {
        postData['custom_order'] = true;
      }
      try {
        const result = await axios.post(ws_vue_store.filtered_attributes_endpoint, postData);

        if (result && result.data && result.data.state == 'OK') {
          if(state.showExcludedAttributes){
            commit('changeShowExcludedAttributes', false);
            commit('changeAttributesFirstLoadingState', true);
          }
          commit("setAttributeTaxonomies", result.data.data.attributes);
          commit('setProductsHighestPrice', result.data.data.max_price);
          commit('setFilteredAttributeTaxonomies', result.data.data.attributes);
        }
      } catch (error) {
        console.error("Request error:", error);
        // TODO: endpoint is messed up
      }
    },
    async addFilter({ dispatch, commit, state }, payload) {
      commit('changeProductsLoadingState', true);

      state.view.page = 1;

      if (payload.taxonomy === "product_cat") {
        commit('changeShowExcludedAttributes', true);
        commit('updatePriceFilter', { 'value': null, 'type': 'min' } );
        commit('updatePriceFilter', { 'value': null, 'type': 'max' } );
        state.filters.current = { product_cat: [payload.option] };
        commit('updateCategoryPath');
      } else {
        commit("addFilter", payload);
      }

      commit("updateUrlQuery");

      dispatch("getFilteredAttributes", [])
      .then(() => dispatch("getProducts", []));
    },
    removeFilter({ dispatch, commit, state }, payload) {
      commit('changeProductsLoadingState', true);
      commit("removeFilter", payload);

      commit("updateUrlQuery");

      dispatch("getFilteredAttributes", [])
      .then(() => dispatch("getProducts", []));
    }
  },
  mounted(){
   self.getFeaturedProducts();
  },
  modules: {}
});
